import React,{useState} from 'react';
import { Navigation, Main, Footer, UnauthorizedDialog } from './components';
import AppContext from './components/AppContext';
import {useLocation} from 'react-router-dom';
import { useHistory } from "react-router";
import { Helmet, HelmetProvider } from 'react-helmet-async';

import './App.css';

function App() {
  const [user, setUser] = useState({});
  const globalState = {
    user: user,
    setUser
  };
  const helmetContext = {};

  return (
    <div className="App">
      <AppContext.Provider value={globalState}>
        <HelmetProvider context={helmetContext}>
          <Navigation history={useHistory()} location={useLocation()}/>
          <UnauthorizedDialog />
          <Main />
          <Footer />
        </HelmetProvider>
      </AppContext.Provider>
    </div>
  );
}

export default App;
